import type {
  WebCollectionFindOneContentTypesDeepOutputDto,
  WebOtherTagFindOneContentTypesDeepOutputDto,
  WebTagFindOneContentTypesDeepOutputDto,
} from '@bldsoft/ovp-api-types'
import { type ContentType, ContentTypeDefault } from '@setplex/tria-api'

type ContentTypesWireDto =
  | Pick<
      WebCollectionFindOneContentTypesDeepOutputDto,
      'movies' | 'live' | 'tvShow'
    >
  | Pick<WebTagFindOneContentTypesDeepOutputDto, 'movies' | 'live' | 'tvShow'>
  | Pick<WebOtherTagFindOneContentTypesDeepOutputDto, 'movies' | 'tvShow'>

// automatically excluding 'content' type - it is not used here, but used in other platforms
export const formatContentType = (dto: ContentTypesWireDto): ContentType => ({
  [ContentTypeDefault.movie]: dto.movies,
  [ContentTypeDefault.tvshow]: dto.tvShow,
  [ContentTypeDefault.liveChannel]: 'live' in dto ? dto.live : undefined,
})
